import { getResolvedColor } from "./colors";

/**
 * Event marker type — shared by ChartEventMarkers and ChartEventSpans.
 */
export type EventMarkerType = "command" | "alert" | "info" | "success" | "warning" | "error";

/**
 * Get the resolved color for a given event marker type.
 * Uses getResolvedColor to ensure CSS variables work in SVG context.
 */
export function getEventColor(type: EventMarkerType | undefined): string {
  switch (type) {
    case "command":
      return getResolvedColor("--color-action-brand", "#111111");
    case "success":
      return getResolvedColor("--color-feedback-success-border", "#278a4a");
    case "warning":
      return getResolvedColor("--color-feedback-warning-border", "#c88420");
    case "error":
      return getResolvedColor("--color-feedback-error-border", "#c42d2d");
    case "alert":
      return getResolvedColor("--color-feedback-warning-border", "#c88420");
    case "info":
    default:
      return getResolvedColor("--color-text-secondary", "#525250");
  }
}
